import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "panel", "label", "input", "option"]

  connect() {
    this.close = this.close.bind(this)
  } // end connect

  disconnect() {
    document.removeEventListener("click", this.close)
  } // end disconnect

  toggle(e) {
    e.preventDefault()
    const isOpen = this.element.classList.toggle("is-open")
    this.toggleTarget.setAttribute("aria-expanded", isOpen)

    if (isOpen) {
      document.addEventListener("click", this.close)
    } else {
      document.removeEventListener("click", this.close)
    }
  } // end toggle

  close(e) {
    if (this.element.contains(e.target)) return

    this.closePanel()
  } // end close

  closePanel() {
    this.element.classList.remove("is-open")
    this.toggleTarget.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this.close)
  } // end closePanel

  select(e) {
    e.preventDefault()
    const option = e.currentTarget
    const value = option.dataset.value

    this.closePanel()

    if (this.inputTarget.value === value) return

    this.optionTargets.forEach(opt => opt.classList.toggle("is-selected", opt === option))
    this.labelTarget.textContent = option.textContent
    this.inputTarget.value = value

    this.element.closest("form").requestSubmit()
  } // end select
}
